import React, { useState, useEffect, useRef } from "react";
import { gl_start, registerSceneHMR, setUniform } from "./webgl0.js";

function Scene() {

this.vertexShader = `\
#version 300 es
in  vec3 aPos;
out vec3 vPos;
void main() {
   gl_Position = vec4(aPos, 1.);
   vPos = aPos;
}`;

this.fragmentShader = `\
#version 300 es
precision highp float;

in  vec3 vPos;
out vec4 fragColor;

uniform float uTime;
uniform vec3 uViewPoint;

vec2 raySphere(vec3 V, vec3 W, vec4 S) {
   V -= S.xyz;

   float b = dot(V, W);
   float d = b * b - dot(V, V) + S.w * S.w;

   float t1 = -b - sqrt(d);
   float t2 = -b + sqrt(d);
   
   if (d < 0.)
      return vec2(1001.,1000.);

   return vec2(t1, t2);
}

vec4 S = vec4(0.,0.,0.,.4);

void main() {
   vec4 F = vec4(0.);
   vec3 V = uViewPoint;
   vec3 W = normalize(vPos-V);
   vec2 t = raySphere(V, W, S);

   float t1 = t.x;
   float t2 = t.y;

   if (t1 < t2 && t1 > 0.0) {
      vec3 P = V + t1 * W;
      fragColor = vec4(vec3(P.z), 1.0);
   }
}`;

let startTime = Date.now()/1000;

this.update = (viewPoint = [0, 0, 7]) => {  // Camera at z=1, looking at sphere at origin
   let time = Date.now() / 1000 - startTime;
   setUniform('1f', 'uTime', time);
   setUniform('3fv', 'uViewPoint', viewPoint);
}

}

export default function WebGLCanvas() {
  const canvasRef = useRef(null);
  const [scene, setScene] = useState(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    try { if (typeof canvas.stopRender === 'function') canvas.stopRender(); } catch (e) {}

    const newScene = new Scene();

    gl_start(canvas, newScene);
    setScene(newScene);

    try { registerSceneHMR(module, canvas, () => new Scene()); } catch (e) { /* ignore in non-HMR env */ }
    return () => { try { if (typeof canvas.stopRender === 'function') canvas.stopRender(); } catch (e) {} };
  }, []);

  return (
    <div style = { { display: "flex", justifyContent: "center", gap : "16px" } }>
        <canvas ref={canvasRef} width = {400} height = {400}  style={{ width : "400px", height : "400px", display: "block", margin: "0 auto", background: "black" }} />
        <pre>{ scene?.fragmentShader }</pre>
    </div>
  );
}
